import { batteries } from "database";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

export const BatteryModel = createInsertSchema(batteries);
export type BatteryModel = z.infer<typeof BatteryModel>;
